module.exports = __webpack_public_path__ + "img/emptyImage.7103cd26.png";